<div class="header-card">
  <div class="header-container">
    <div class="header-left">
      <div class="badge">{{ worktype }}</div>
    </div>
    <div class="header-right">
      <span class="order-id">{{ referenceNumber }}</span>
    </div>
  </div>
  <div class="date-row">
    <img src="assets/images/icons/Date.svg" class="icon" alt="Date Icon" />
    <span>{{ createdAt | date: 'MMM dd yyyy, h:mm a' }}</span>
    <div class="status-right">
      <span class="status-dot"></span>
      <span>{{ status }}</span>
    </div>
  </div>
</div>
